import React, { useState, useEffect } from "react";
import { Editor } from 'react-draft-wysiwyg';
import { convertFromHTML, EditorState, ContentState } from 'draft-js';
import { stateToHTML } from 'draft-js-export-html';
import parse from 'html-react-parser';
import { loginRequest, protectedResources } from "../../authConfig";
//import { useGetSkillData, useUpdateSkillData } from '../../hooks/useSkillData';
import { ISkill } from "../../model/Skill.model";
import { IsCookieFunction } from "react-router-dom";
import useFetchWithMsal from "../../hooks/useFetchWithMsal";
import { ISkillLevel } from "../../model/SkillLevel.model";
import Modal from "../Modal/Modal";
import { useGetSkillDetailsOData } from "../../hooks/useSkillDetailData";
import { ISkillDetail } from "../../model/SkillDetail.model";
import IconHoverButton from "../IconHoverButton/IconHoverButton";
import { Icon } from '../icons/icons';
import './EditSkillDetailsComponent.scss';

const EditingSkillDetailForm: React.FC<{ skillDetail: ISkillDetail, handleEditSkillDetailText(event: any): void }> =
  (props: { skillDetail: ISkillDetail, handleEditSkillDetailText(event: any): void }) => {
    var spd = convertFromHTML((props.skillDetail.skillText) ? props.skillDetail.skillText : "");
    const spdCS = ContentState.createFromBlockArray(spd.contentBlocks, spd.entityMap);
    const [editorState, setEditorState] = useState(EditorState.createWithContent(spdCS));// Toolbar configuration    
    const toolbarOptions = {
      options: ['inline', 'list', 'link', 'history'],
      inline: {
        options: ['bold', 'italic', 'underline'],
      },
      list: {
        options: ['unordered', 'ordered'],
      },
      link: {
        options: ['link', 'unlink'],
      },
      history: {
        options: ['undo', 'redo']
      }
    };
    const onEditorStateChange = (newEditorState: EditorState) => {
      //debugger;
      setEditorState(newEditorState);
      const contentState = editorState.getCurrentContent();
      //setDescription(stateToHTML(contentState));
    };
    const HandleEditDetailText = (event: any) => {
      event.preventDefault();
      const formData = new FormData(event.target);
      //const newSkillDetailText = formData.get("newSkillDetailText");
      let testbloc = stateToHTML(editorState.getCurrentContent()) + "";
      props.skillDetail.skillText = testbloc;
      //debugger;
      props.handleEditSkillDetailText(props.skillDetail);
      setEditorState(EditorState.createEmpty());
    }
    return( 
    <form onSubmit={HandleEditDetailText}>
      <div className="modal-form-content-scroll-container">
        <Editor editorState={editorState} onEditorStateChange={onEditorStateChange} toolbar={toolbarOptions} />
      </div>
      <div className="modal-form-button-container">
        <input className="btn-primary" type="submit" value={"Update"}></input>
      </div>
    </form>
    )
  }

const NewSkillDetailTextForm: React.FC<{ skillLevel: ISkillLevel, handleAddNewDetailText(event: any): void }> =
  (props: { skillLevel: ISkillLevel, handleAddNewDetailText(event: any): void }) => {
    //  var spd = convertFromHTML((skillPath.skillPathDescription) ? skillPath.skillPathDescription : "");
    //  const spdCS = ContentState.createFromBlockArray(spd.contentBlocks, spd.entityMap);
    const [editorState, setEditorState] = useState(EditorState.createEmpty());// Toolbar configuration    
    const toolbarOptions = {
      options: ['inline', 'list', 'link', 'history'],
      inline: {
        options: ['bold', 'italic', 'underline'],
      },
      list: {
        options: ['unordered', 'ordered'],
      },
      link: {
        options: ['link', 'unlink'],
      },
      history: {
        options: ['undo', 'redo']
      }
    };
    const onEditorStateChange = (newEditorState: EditorState) => {
      //debugger;
      setEditorState(newEditorState);
      const contentState = editorState.getCurrentContent();
      //setDescription(stateToHTML(contentState));
    };
    const HandleAddNewDetailText = (event: any) => {
      event.preventDefault();
      const formData = new FormData(event.target);
      //const newSkillDetailText = formData.get("newSkillDetailText");
      const newSkillLevel = formData.get("newSkillLevel");
      let testbloc = stateToHTML(editorState.getCurrentContent()) + "";

      //debugger;
      props.handleAddNewDetailText({ newSkillLevel: newSkillLevel, newSkillDetailText: testbloc });
      setEditorState(EditorState.createEmpty());
    }
    return (
    <form onSubmit={HandleAddNewDetailText}>
      <Editor editorState={editorState} onEditorStateChange={onEditorStateChange} toolbar={toolbarOptions} />
      <input type="hidden" name="newSkillLevel" value={props.skillLevel.skillLevelId} />
      <div className="aln-center m-t--50">
        <input className="btn-outlined-secondary-sml" type="submit" value={"Add new detail"}></input>
      </div>
    </form>)
  }

const EditSkillDetailsComponent: React.FC<{
  Skill: ISkill;
  SkillLevels: ISkillLevel[];
  addNewSkillData(event: ISkill): void;
  updateSkillData(event: ISkill): void;
}> = (props: {
  Skill: ISkill;
  SkillLevels: ISkillLevel[];
  addNewSkillData(event: ISkill): void;
  updateSkillData(event: ISkill): void;
}) => {
    var Skill = props.Skill;
    console.log("form component w name ", Skill.skillName);
    //const [skillDetails,loading, error, callErr ] = useGetSkillDetailsOData(`$filter=Skillid eq '${Skill.SkillId}'&$orderby=indexNumber`, false);
    const { error, execute } = useFetchWithMsal({
      scopes: protectedResources.apiCFSkillPath.scopes.read,
    });
    const [loading, setLoading] = useState(true);
    const [callErr, setErr] = useState(null);
    const [SkillDetails, setSDData] = useState<ISkillDetail[] | null>(null);
    const [editingSkillDetail, setEditingSkillDetail] = useState<ISkillDetail | null>(null);
    const [odataStringSt, setOdataStringSt] = useState("");
    var odataString = `$filter=Skillid eq '${Skill.SkillId}'&$orderby=indexNumber`;
    if (Skill.SkillId === "") {
      odataString = "";
    }
    useEffect(() => {
      //setSLData(null);
      let odataStringEnc = encodeURIComponent(odataString);
      if (
        Skill &&
        odataString.length &&
        props.SkillLevels &&
        (odataStringSt !== odataString || SkillDetails === null)
      ) {
        execute(
          "GET",
          `/api/SkillDetail/odata/${odataStringEnc}`,
          undefined
        )
          .then((response) => {
            if (response.error) {
              return;
            }
            setSDData(response);
            console.log("new detail data", response);
            setLoading(false);
            setOdataStringSt(odataString);
          })
          .catch((err) => {
            setErr(err);
            setLoading(false);
          });
      }
    }, [
      execute,
      SkillDetails,
      odataString,
      odataStringSt,
      props.Skill,
      props.SkillLevels,
    ]);
    const [name, setName] = useState(Skill.skillName);

    //setName(Skill.SkillName);
    const HandleSubmit = (event: any) => {
      event.preventDefault();
      const formData = new FormData(event.target);
      const inputSN = formData.get("SkillName");
      if (inputSN) Skill.skillName = inputSN + "";
      Skill.skillDescription = formData.get("skillDescription") + "";
      if (Skill.SkillId === "") {
        props.addNewSkillData(Skill);
      } else {
        props.updateSkillData(Skill);
      }
    };
    const skillDetailFiltered = (skillLevel: ISkillLevel) => {
      if (!SkillDetails) return [];
      return (SkillDetails as ISkillDetail[]).filter(
        (x: ISkillDetail) => x.skillLevelId === skillLevel.skillLevelId
      );
    };
    const DeleteSkillDetail = (detail: ISkillDetail) => {
      execute(
        "DELETE",
        `/api/SkillDetail/deleteSkillDetail/${detail.skillDetailId}`,
        undefined
      )
        .then((response) => {
          if (response.error) {
            return;
          }
          //setSLData(response);
          if (SkillDetails && SkillDetails.indexOf(detail) > -1) {
            SkillDetails.splice(SkillDetails.indexOf(detail), 1);
            setSDData(SkillDetails);
          }
          console.log("deleted detail data", detail);
          //setLoading(false);
          //setOdataStringSt(odataString);
        })
        .catch((err) => {
          setErr(err);
          //setLoading(false);
        });
    }
    const HandleEditSkillDetailText = (detail: ISkillDetail) => {
      execute(
        "PUT",
        `/api/SkillDetail/updateSkillDetail`,
        detail as any
      )
        .then((response) => {
          if (response.error) {
            return;
          }
          //setSLData(response);
          setSDData(SkillDetails);
          setLoading(false);
          //setOdataStringSt(odataString);
          setEditingSkillDetail(null);
        })
        .catch((err) => {
          setErr(err);
          setLoading(false);
        });
    }
    const ToggleEditingSkillDetail = (detail: ISkillDetail | null) => {
      setEditingSkillDetail(detail);
    }
    const ToggleDeletingSkillDetail = (event: ISkillDetail) => {
      DeleteSkillDetail(event);
    }
    const handleAddNewDetailText = (event: any) => {
      //event.preventDefault();
      //const formData = new FormData(event.target);
      const newSkillDetailText = event.newSkillDetailText;// formData.get("newSkillDetailText");
      const newSkillLevel = event.newSkillLevel;//formData.get("newSkillLevel");
      var newIndex = 0;
      if (newSkillDetailText === null || !newSkillLevel) {
        return;
      }
      if (SkillDetails) {
        let sdets = (SkillDetails as any[]).filter(sd => sd.skillLevelId === newSkillLevel);
        newIndex = sdets.reduce((v, sd) => {
          console.log(sd, v); if (sd.indexNumber > v) return sd.indexNumber;
          else
            return v
        }, 1);
      }
      const skillDetail: ISkillDetail = {
        skillDetailId: "",
        SkillId: Skill.SkillId,
        skillLevelId: newSkillLevel + "",
        indexNumber: newIndex + 1,
        skillText: newSkillDetailText + "",
        createdDate: "",
        CreatedBy: "",
        lastModifiedDate: "",
        lastModifiedBy: "",
      };
      execute(
        "POST",
        `/api/SkillDetail/addSkillDetail`,
        skillDetail as any
      )
        .then((response) => {
          if (response.error) {
            return;
          }
          //setSLData(response);
          (SkillDetails as any).push(response);
          setSDData(SkillDetails);
          console.log("new detail data", response);
          setLoading(false);
          //setOdataStringSt(odataString);
        })
        .catch((err) => {
          setErr(err);
          setLoading(false);
        });
    };

    return (
      <>
        <div className="modal-form-content-scroll-container edit-skill-details">
          <form onSubmit={HandleSubmit} className="modal-form">
            <div>
              <div className="form-group m-b-1">
                <label htmlFor="skillName">Name</label>
                <input id="skillName" type="text" name="SkillName" defaultValue={name} />
              </div>

              <div className="form-group m-b-1">
                <label htmlFor="skillDescription">Description</label>
                <input id="skillDescription" type="text" name="skillDescription" defaultValue={Skill?.skillDescription} />
              </div>
            </div>
            {Skill.SkillId !== "" && <div className="aln-center"><button className="btn-primary" type="submit">Update</button></div>}
            {Skill.SkillId === "" && (
             <div className="aln-center"><button className="btn-primary" type="submit">Add New Skill</button></div>
            )}
          </form>
          {editingSkillDetail !== null && (
            <Modal modalTitle="Edit Skill Detail" onClose={() => ToggleEditingSkillDetail(null)} isOpen={editingSkillDetail !== null}>
              <EditingSkillDetailForm skillDetail={editingSkillDetail} handleEditSkillDetailText={HandleEditSkillDetailText} />
            </Modal>)}
          {Skill.SkillId !== "" &&
            props.SkillLevels.length > 0 &&
            props.SkillLevels.map((sl: any) => (
              <>
                <hr className="m-t-2 m-b-2 clr-light-gray" />
                <h2 className="h3-size m-b--75">{sl.skillLevelName}</h2>
                <div className="m-l-1-5 m-b-1 edit-skill-details-text-container">
                  {skillDetailFiltered(sl).length > 0 &&
                    skillDetailFiltered(sl).map((detail) => {
                      return (
                      <>
                        <>{parse(detail.skillText)}</>
                        <div className="dis-flex dis-flex-jst-center gap--50">
                          <button className='btn-outlined-primary-sml' onClick={(e) => ToggleEditingSkillDetail(detail)} title='Edit Skill'>
                            Edit
                          </button>
                          <button className='btn-outlined-primary-sml' onClick={() => ToggleDeletingSkillDetail(detail)} title='Delete Skill'>
                            Delete
                          </button>
                        </div>

                      </>
                    )})}
                </div>
                <NewSkillDetailTextForm skillLevel={sl} handleAddNewDetailText={handleAddNewDetailText} />

              </>
            ))}
        </div>
      </>
    );
  };

export default EditSkillDetailsComponent;
